import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography
} from '@mui/material'
import PropTypes from 'prop-types'

function UploadDialog({
  isUpdatePicDialogOpen,
  setIsUpdatePicDialogOpen,
  setUpdatedProfilePic,
  handleUpdatePic
}) {
  return (
    <Dialog
      open={isUpdatePicDialogOpen}
      onClose={() => setIsUpdatePicDialogOpen(false)}
    >
      <DialogTitle>
        <Typography variant='h4'>Upload Picture</Typography>
      </DialogTitle>
      <DialogContent>
        <input
          type='file'
          onChange={(e) => setUpdatedProfilePic(e.target.files[0])}
          style={{ marginBottom: '1rem' }}
        />
        <Link>
          <Typography variant='subtitle1'>
            Supported file types: png, jpg
            <br />
            Maximum file size: 2 MB
          </Typography>
        </Link>
      </DialogContent>
      <DialogActions>
        <Button
          variant='secondary'
          sx={{ backgroundColor: 'transparent' }}
          onClick={() => setIsUpdatePicDialogOpen(false)}
        >
          Cancel
        </Button>
        <Button variant='filled' onClick={handleUpdatePic}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

UploadDialog.propTypes = {
  isUpdatePicDialogOpen: PropTypes.bool,
  setIsUpdatePicDialogOpen: PropTypes.func,
  setUpdatedProfilePic: PropTypes.func,
  handleUpdatePic: PropTypes.func
}

export default UploadDialog
